var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jump-cart"},[_c('van-nav-bar',{staticClass:"jump-nav-bar",attrs:{"title":"订单信息","left-arrow":"","fixed":""},on:{"click-left":_vm.back}}),_c('div',{staticClass:"jump-cart-body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }